import * as React from "react";
import {useProductDetailsQuery} from "../hooks/useProductDetailsQuery";
import {useAppContext} from "../hooks/useAppContext";

export const BreadCrumbs = () => {
    const {breadCrumbs} = useAppContext();

    if (breadCrumbs.length < 1) return <></>;

    return (

        <>
            <div className="fw-bold text-end" style={{ height: '24px' }}>SKU: <Sku /></div>
            <div className="clearfix breadcrumb-list w-100" style={{ height: '43px' }}>
                <ol
                    itemType="https://schema.org/BreadcrumbList"
                    className="custom-breadcrumb product-breadcrumb">
                    {breadCrumbs.map((breadCrumb, index) => {
                        if (index === breadCrumbs.length - 1)
                            return <li key={index} className="active breadcrumb-sku">{" "}<Sku />{" "}</li>

                        return (
                            <li
                                itemProp="itemListElement"
                                itemScope
                                key={index}
                            >
                                <a href={breadCrumb.url} itemProp="item" tabIndex={0} role="link" className="me-2">
                                    <meta itemProp="position" content={index.toString()} />
                                    <span itemProp="name">{breadCrumb.text}</span>
                                </a>
                            </li>
                        );
                    }
                    )}
                </ol>
            </div>
        </>

    )
}

const Sku = () => {
    const {sku: initialSku} = useAppContext();
    const {model: {sku}} = useProductDetailsQuery();
    return <>{sku ?? initialSku}</>;
};